function Blogs() {
  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      Blogs: under development
    </div>
  );
}

export default Blogs;
